import apiClient from "./apiClient";

export type SubscriptionType = "essential" | "starter" | "growth" | "professional" | "premium" | "enterprise";
export type FrequencyType = "monthly" | "yearly";
export type CreditsType = "memorial";
export type CreditsSize = 1;
export type CandleType = "original" | "deluxe";
export type CandleColour = "amethyst" | "burgundy" | "forest" | "midnight" | "rose gold";

export type SubscriptionPlan = {
    key: SubscriptionType;
    displayName: string;
    monthlyCreditAllocation: number;
    additionalMemorialRateCents: number;
    monthlyPriceCents?: number;
    yearlyPriceCents: number;
    isPopular: boolean;
};

export const purchaseSubscription = async (
    subscriptionType: SubscriptionType,
    frequency: FrequencyType,
    coupon?: string,
): Promise<string> => {
    try {
        const response = await apiClient.post("/payment/purchase-subscription", {
            subscriptionType, frequency, coupon,
        });
        return response.data.sessionId;
    } catch (error) {
        console.error("Failed to purchase subscription.", error);
        throw error;
    }
};

export const purchaseCredits = async (
    creditsType: CreditsType,
    creditsSize: CreditsSize,
    memorialId?: string, // Provide for upgrading a memorial
    serviceId?: string, // Provide for creating memorial from service
)
: Promise<string> => {
    try {
        const response = await apiClient.post("/payment/purchase-credits", {
            creditsType, creditsSize, memorialId, serviceId,
        });
        return response.data.sessionId;
    } catch (error) {
        console.error("Failed to purchase credits.", error);
        throw error;
    }
};

export const purchaseCandle = async (
    candleType: CandleType,
    candleColour: CandleColour,
    memorialId?: string,
)
: Promise<string> => {
    try {
        const response = await apiClient.post("/payment/purchase-candle", {
            candleType, candleColour, memorialId,
        });
        return response.data.sessionId;
    } catch (error) {
        console.error("Failed to purchase candle.", error);
        throw error;
    }
};

export const getSubscriptionPlans = async (): Promise<SubscriptionPlan[]> => {
    try {
        const response = await apiClient.get("/payment/plans");
        return response.data.plans;
    } catch (error) {
        console.error("Failed to fetch subscription plans.", error);
        throw error;
    }
};

export const getCustomerPortal = async (): Promise<string> => {
    try {
        const response = await apiClient.get("/payment/portal");
        return response.data.portalUrl;
    } catch (error) {
        console.error("Failed to get customer portal.", error);
        throw error;
    }
};

export type PromoCodeValidationResult = {
    isValid: boolean;
};

export const validatePromoCode = async (promoCode: string): Promise<PromoCodeValidationResult> => {
    try {
        const response = await apiClient.post("/payment/validate-promo-code", { promoCode });
        return response.data;
    } catch (error) {
        console.error("Failed to validate promotion code.", error);
        throw error;
    }
};
